/**
 * =============================================================================
 * IDS CRM Web - Shared EngineerSelect (Batch E UX system)
 * =============================================================================
 *
 * One engineer dropdown for the whole app. The valueKey is EXPLICIT because
 * different endpoints key engineers differently (user_id vs engineer_id) -
 * silently guessing is the exact bug class of B2/B13. If a row is missing the
 * declared key the option is skipped and a console warning names the row, so
 * mixed-key payloads surface in dev instead of saving the wrong id.
 *
 * =============================================================================
 */

import React from 'react';

function EngineerSelect({
  engineers = [],
  valueKey,
  value,
  onChange,
  name,
  id,
  placeholder = 'Select engineer...',
  required = false,
  disabled = false,
  className
}) {
  if (!valueKey) {
    console.warn('EngineerSelect: valueKey prop is required (user_id or engineer_id)');
  }

  return (
    <select
      name={name}
      id={id}
      value={value}
      onChange={onChange}
      required={required}
      disabled={disabled}
      className={className}
    >
      <option value="">{placeholder}</option>
      {engineers.map(engineer => {
        const optionValue = engineer[valueKey];
        if (optionValue === undefined || optionValue === null) {
          console.warn(`EngineerSelect: engineer row missing ${valueKey}:`, engineer.full_name);
          return null;
        }
        return (
          <option key={optionValue} value={optionValue}>
            {engineer.full_name || engineer.preferred_name || 'Unknown'}
          </option>
        );
      })}
    </select>
  );
}

export default EngineerSelect;
